<template>
    <div>
        <div class="p-md-3 my-2 notification-wrapper card" :class="{'bg-unread': isNew}">
            <div class="card-body">
                <div class="row">
                    <div class="col-2 col-md-1 text-end text-notification-header-color">
                        <div class="px-1">
                            <svg xmlns="http://www.w3.org/2000/svg" class="notification-icon" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" :d="notificationIcon" clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                    <div class="col-6 col-md-7 text-notification-header-color">
                        <small class="text-xs">
                            {{ readableNotificationType }}
                        </small>
                    </div>
                    <div class="col-4 text-end text-notification-header-color">
                        <div class="mr-2">
                            <small class="text-xs">{{ notification.formattedNotificationDate }}</small>
                        </div>
                    </div>
                    <div class="offset-2 col-9 offset-md-1 col-md-10 text-notification-body-color">
                        <small v-html="notification.message"></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps(['notification'])

const isNew = computed(() => props.notification.read === '0000-00-00 00:00:00')

const notificationType = computed(() => {
    if (props.notification.message.indexOf('kansellert') > -1) {
        return 'booking'
    }
    switch(props.notification.message_type) {
        case 'message_log':
            return 'tc'
        case 'notification':
        default:
            return 'notification'
    }
})

const readableNotificationType = computed(() => {
    switch (notificationType.value) {
        case 'booking':
            return $t('Booking')
        case 'tc':
            return $t('Opplæring')
        case 'notification':
        default:
            return $t('Varsel')
    }
})

const notificationIcon = computed(() => {
    switch(notificationType.value) {
        case 'booking':
            return 'M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z'
        case 'tc':
        default:
            return 'M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z'
    }
})
</script>
